/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_LockedInputs */



/**
* | output |
* | --- |
* | "Locked" |
*
* @param {Decks_LockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_locked = /** @type {((inputs?: Decks_LockedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_LockedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouillé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Bloqueado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bloccato")
	return /** @type {LocalizedString} */ ("Locked")
});